<div class="promo-banner" *ngIf="!isExpired" (click)="copyToClipboard()">
  <div class="promo-content">
    <div class="promo-offer">
      <div class="promo-line-1">
        <span class="promo-percent">-{{ procent }}%</span>
        <span class="promo-text promo-text-1">{{ tekst1 }}</span>
      </div>
      <div class="promo-line-2">
        <span class="promo-text promo-text-2">{{ tekst2 }}:</span>
        <div class="promo-code-wrapper">
          <span class="promo-code">{{ isCopied ? 'SKOPIOWANO' : kod }}</span>
          <svg class="copy-icon" (click)="copyToClipboard(); $event.stopPropagation()" title="Kopiuj kod" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M3 11V3C3 2.44772 3.44772 2 4 2H11" stroke="currentColor" stroke-width="1.5" fill="none"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="promo-countdown">
      <div class="countdown-wrapper">
        <div class="countdown-item">
          <span class="time-value">{{ formatTime(days) }}</span>
          <span class="time-label">dni</span>
        </div>
        <span class="time-separator">:</span>
        <div class="countdown-item">
          <span class="time-value">{{ formatTime(hours) }}</span>
          <span class="time-label">godz</span>
        </div>
        <span class="time-separator">:</span>
        <div class="countdown-item">
          <span class="time-value">{{ formatTime(minutes) }}</span>
          <span class="time-label">min</span>
        </div>
        <span class="time-separator">:</span>
        <div class="countdown-item">
          <span class="time-value">{{ formatTime(seconds) }}</span>
          <span class="time-label">sek</span>
        </div>
      </div>
    </div>
  </div>
</div>

